<template>
  <div class="container" ref="container">
    <div class="content" v-html="companyDescription"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      translations: {
        en: `
          <div>
            <p>Stadssalg AS is a liquidation company running online auctions and has branches in Bodø, Tromsø, Trondheim, Stavanger, Bergen, Grimstad, and Oslo.</p>
            <p>Our clients include:</p>
            <ul>
              <li>Banks</li>
              <li>Finance</li>
              <li>Public agencies</li>
              <li>Debt collection agencies</li>
              <li>Lawyers/trustees</li>
            </ul>
            <p>We sell thousands of items annually through our online auctions.</p>
          </div>
        `,
        no: `
          <div>
            <p>Stadssalg AS er et avviklingsselskap som driver med nettauksjon og har avdelinger i Bodø, Tromsø, Trondheim, Stavanger, Bergen, Grimstad og Oslo.</p>
            <p>Våre oppdragsgivere er blant annet:</p>
            <ul>
              <li>Bank</li>
              <li>Finans</li>
              <li>Offentlige etater</li>
              <li>Inkassobyråer</li>
              <li>Advokater/bostyre</li>
            </ul>
            <p>Vi selger flere tusen objekter årlig gjennom våre nettauksjoner.</p>
          </div>
        `
      }
    };
  },
  computed: {
    companyDescription() {
      const locale = this.$i18n.locale;
      return this.translations[locale] || this.translations["no"];
    }
  }
};
</script>

<style></style>
